module.exports = __webpack_public_path__ + "img/feat-craft-the-perfect-custom-experience.b6d40a4c.svg";